module.exports = __webpack_public_path__ + "img/imggheader.0aa06430.svg";